module.exports = __webpack_public_path__ + "img/app-pay.c6e4963c.webp";